import React, { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Input, Typography } from "@material-tailwind/react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { loginUser } from "@/redux/slices/userSlices";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { InformationCircleIcon } from "@heroicons/react/24/solid";
import { UserSubmitForm } from "@/utils/interface.global";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import btn_login from "@/assets/btn_login.png";
import cloud_1 from "@/assets/cloud_1.png";
import cloud_2 from "@/assets/cloud_2.png";
import cloud_3 from "@/assets/cloud_3.png";
import cum_xe from "@/assets/cum_xe.png";

const formSchema = Yup.object().shape({
  codeStore: Yup.string()
    .required("Mã cửa hàng không được để trống")
    .min(4, "Mã cửa hàng phải có ít nhất 4 ký tự"),
  password: Yup.string()
    .required("Mật khẩu không được để trống")
    .min(3, "Mật khẩu phải có ít nhất 3 số"),
});

const Login: React.FC = () => {
  const [isPassword, setIsPassword] = useState(true);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserSubmitForm>({
    mode: "onTouched",
    resolver: yupResolver(formSchema),
  });

  const handleSubmitForm = (values: UserSubmitForm) => {
    dispatch(loginUser(values));
  };

  return (
    <div className="login-container relative">
      {/* Cloud 1 - Top Right */}
      <div className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2">
        <img src={cloud_1} className="w-28" alt="Cloud 1" />
      </div>

      {/* Cloud 2 - Bottom Right */}
      <div className="absolute bottom-0 right-0 transform translate-x-1/2 translate-y-1/2">
        <img src={cloud_2} className="w-28" alt="Cloud 2" />
      </div>

      {/* Cloud 3 - Bottom Left */}
      <div className="absolute bottom-0 left-0 transform -translate-x-1/2 translate-y-1/2">
        <img src={cloud_3} className="w-28" alt="Cloud 3" />
      </div>
      <div className="absolute bottom-0 left-0 transform -translate-x-1/2 translate-y-1/2">
        <img src={cum_xe} className="w-[90%]" alt="Cloud 3" />
      </div>
      <h1 className="text-xl md:text-2xl sm:text-2xl font-bold">
        Thông Tin Đăng Nhập
      </h1>
      <div className="w-5/6 flex flex-col gap-5 py-5">
        <Input
          {...register("codeStore")}
          variant="standard"
          color="gray"
          label="Mã Cửa Hàng"
          error={errors.codeStore && true}
        />
        {errors.codeStore && (
          <Typography
            variant="small"
            color="red"
            className="flex items-center gap-1 font-normal mx-2"
          >
            <InformationCircleIcon className="w-4 h-4 -mt-px" />
            {errors.codeStore.message!}
          </Typography>
        )}
        <Input
          {...register("password")}
          variant="standard"
          color="gray"
          label="Mật Khẩu"
          type={isPassword ? "password" : "text"}
          error={errors.password && true}
          icon={
            isPassword ? (
              <AiOutlineEye
                className="cursor-pointer"
                onClick={() => setIsPassword(!isPassword)}
              />
            ) : (
              <AiOutlineEyeInvisible
                className="cursor-pointer"
                onClick={() => setIsPassword(!isPassword)}
              />
            )
          }
        />
        {errors.password && (
          <Typography
            variant="small"
            color="red"
            className="flex items-center gap-1 font-normal mx-2"
          >
            <InformationCircleIcon className="w-4 h-4 -mt-px" />
            {errors.password.message!}
          </Typography>
        )}
      </div>
      <div className="w-full flex z-10">
        <button
          className="w-[30%] mx-auto"
          onClick={handleSubmit(handleSubmitForm)}
        >
          <img src={btn_login} />
        </button>
      </div>
    </div>
  );
};

export default Login;
